<template>
  <div>
    <div
      style="
        background: white;
        width: 100%;
        height: 100vh;
        z-index: 10;
        top: 0;
        position: fixed;
      "
      v-if="isActiveHamburgerMenu"
    >
      <div
        class="d-flex"
        style="height: 50px; align-items: center; margin-left: 16px"
      >
        <img
          src="/img/blog_logo.png"
          style="width: 190px; height: 30px"
          @click="goToHomePage"
        />
        <div
          style="
            justify-content: right;
            display: inline-flex;
            margin-right: 16px;
            width: 100%;
          "
        >
          <img
            src="/img/other/ic_menu.png"
            style="width: 24px; height: 24px; cursor: pointer"
            @click="closeMenu"
          />
        </div>
      </div>

      <div style="background: #f1f1f1; width: 100%; height: 1px"></div>
      <HamburgerMenu v-if="isActiveHamburgerMenu" />
    </div>

    <div
      class="text-center header-mobile-custom"
      v-if="
        mobileView &&
        this.$route.path != '/' &&
        this.$route.path != '/services' &&
        this.$route.path != '/corporate'
      "
    >
      <img
        src="/img/logo.png"
        style="width: 150px; height: 100px"
        @click="goToHomePage"
      />
      <div
        style="
          justify-content: right;
          display: inline-flex;
          margin-right: 16px;
          width: 100%;
        "
      >
        <img
          src="/img/other/ic_menu.png"
          style="width: 24px; height: 24px; cursor: pointer"
          @click="openMenu"
        />
      </div>
    </div>
    <div class="text-center header-mobile-custom" v-if="mobileView">
      <img
        src="/img/blog_logo.png"
        style="width: 150px"
        @click="goToHomePage"
      />
      <div class="hamburger-menu">
        <img
          src="/img/other/ic_menu.png"
          style="width: 24px; height: 24px; cursor: pointer"
          @click="openMenu"
        />
      </div>
    </div>
    <HeaderBlog v-if="!mobileView" />
    <router-view></router-view>
    <FooterBlog />
  </div>
</template>

<script>
import HeaderBlog from "@/components/HeaderBlog.vue";
import FooterBlog from "@/components/FooterBlog.vue";
import HamburgerMenu from "@/components/HamburgerMenu";

export default {
  name: "BlogTemplate",
  data() {
    return {
      isActiveHamburgerMenu: false,
      mobileView: false,
    };
  },
  components: {
    HeaderBlog,
    FooterBlog,
    HamburgerMenu
  },
  methods: {
    handleView() {
      // this.mobileView = window.innerWidth <= 990
      if (window.innerWidth <= 990) {
        this.mobileView = true
        this.isShow = false;
      }
    },
    specialCaseView() {
      if(this.$route.path == "/login" || this.$route.name == "PrivacyPolicyMobile" || this.$route.name == "TermConditionMobile") {
        this.isShow = false
        this.mobileView = false
        this.isNavMobileShow = false
      }

      // if(this.$route.path == "/" ) {
      //   this.isShow = false
      //   this.mobileView = true 
      //   this.isNavMobileShow = true
      // }
    },
    customHeader() {
      if (this.$route.path == "/") {
        this.isCustomHeader = true;
      }
    },
    openMenu() {
      this.isActiveHamburgerMenu = true;
    },
    closeMenu() {
        this.isActiveHamburgerMenu = false;
    },
    isPageFound() {
      if (this.$route.matched[0].path == "*") {
        this.isShow = false
      }
    },
    goToHomePage() {
      window.location.href = '/';
    }    
  },
  mounted() {
    this.handleView();
  },
};
</script>
<style scoped>
.header-mobile-custom {
  display: flex;
  padding-left: 16px;
  align-items: center;
  background-color: white;
  width: 100%;
  top: 0;
  height: 60px;
  position: fixed !important;
  z-index: 9;
  box-shadow: 1px 3px 5px 1px rgba(13, 28, 113, 0.1) !important;
  cursor: pointer;
}
.nav-mobile {
  background: white;
  width: 100%;
  height: 100vh;
  top: 0;
  z-index: 10;
  padding: 30px;
  position: fixed;
}
.hamburger-menu {
  justify-content: right;
  display: inline-flex;
  margin-right: 16px;
  width: 100%;
}
.ic-close-right {
  display: flex;
  justify-content: flex-end;
}
.contact-me {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
</style>
